import * as React from 'react';
import { withTranslator } from '../../helpers/shared';
import { RenderHtml } from '../../helpers/render-html';

export const WixSsoError = (props: withTranslator) => {
	const compTranslate = (key: string) => props.t(`marketing-site.signup.wix-sso-error.${key}`);

	return (
		<div className='wix-sso-error'>
			<h1>{compTranslate('title')}</h1>
			<p><RenderHtml html={compTranslate('description')}/></p>
			<p><RenderHtml html={compTranslate('contact')}/></p>
		</div>
	);
};
